import dashboard from './dashboard'
import activity from './activity'

export default {
  ...dashboard,
  ...activity,
}
